import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CashpaymentService } from '../../../../../core';
import { DataTableColumn } from '../../../../../shared/ui/data-table/data-table.component';

@Component({
  selector: 'app-status-history-modal',
  templateUrl: './status-history-modal.component.html',
  styleUrls: ['./status-history-modal.component.scss']
})
export class StatusHistoryModalComponent implements OnChanges {
  @Input() isOpen: boolean = false;
  @Input() cashPaymentId: any;
  @Input() companyId: any;

  @Output() close = new EventEmitter<void>();

  statusHistoryList: any[] = [];
  loading: boolean = false;
  currentPage: number = 1;
  pageSize: number = 5;

  columns: DataTableColumn[] = [
    { field: 'name', header: 'Status' },
    { field: 'updatedOn', header: 'Updated On' }
  ];

  constructor(private cashPaymentService: CashpaymentService) {}

  ngOnChanges(changes: SimpleChanges): void {
    const openedNow = changes['isOpen'] && this.isOpen;
    const rowChanged = changes['cashPaymentId'] && this.isOpen && this.cashPaymentId;
    if ((openedNow || rowChanged) && this.cashPaymentId) {
      this.loadHistory();
    }
    if (changes['isOpen'] && !this.isOpen) {
      this.statusHistoryList = [];
      this.currentPage = 1;
    }
  }

  get rows(): any[] {
    const all = (this.statusHistoryList || []).map((item: any) => ({
      name: item.name,
      updatedOn: item.updatedOn
        ? new Date(item.updatedOn).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
        : '-'
    }));
    const start = (this.currentPage - 1) * this.pageSize;
    return all.slice(start, start + this.pageSize);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  private loadHistory(): void {
    this.loading = true;
    this.currentPage = 1;
    const req = 'companyId=' + this.companyId + '&cashPaymentId=' + this.cashPaymentId;
    this.cashPaymentService.getStatusHistoryOfConsolidatedCashpaymentData(req).subscribe(
      (response: any) => {
        this.loading = false;
        this.statusHistoryList = response || [];
      },
      () => {
        this.loading = false;
      }
    );
  }
}
